var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraggingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8580"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Edit report"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7914",
    fill: "rgba(82,34,242,0.58)",
    transform: "rotate(180 9.5 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 112",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 113",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(7)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 114",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(14)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Edit report"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7914",
    fill: "rgba(82,34,242,0.58)",
    transform: "rotate(180 9.5 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 112",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 113",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(7)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 114",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(14)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggingIcon);
export default __webpack_public_path__ + "static/media/dragging-icon.4d6f506a050f7ef5dc1b529c8e287ba7.svg";
export { ForwardRef as ReactComponent };